/* EBH — «avisa-me quando voltar» (2026-09-12)
   ---------------------------------------------------------------------------
   O formulário nasce escondido e aparece quando a variante escolhida está
   esgotada. Quem decide isso é o próprio botão de comprar: o tema põe-lhe
   `disabled` quando não há stock, e observar esse atributo funciona com
   qualquer selector de variante — não é preciso saber como o tema o desenha.

   ⚠️ A variante muda sem recarregar a página. Ler o stock uma vez no arranque
      deixava o pedido escondido para quem trocasse de cor.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var caixa = document.querySelector('[data-ebh-bis]');
  if (!caixa) return;

  /* Há mais do que um botão de comprar na ficha (o principal e o da barra
     fixa). Observam-se todos: se algum diz esgotado, está esgotado. */
  var botoes = [].slice.call(document.querySelectorAll('[data-add-to-cart]'));
  var form = caixa.querySelector('[data-bis-form]');
  var nota = caixa.querySelector('[data-bis-nota]');
  var PEDIDOS = 'ebh:bis:v1';

  function jaPediu(variante) {
    try { return (JSON.parse(localStorage.getItem(PEDIDOS) || '[]') || []).indexOf(variante) !== -1; }
    catch (e) { return false; }
  }
  function guardaPedido(variante) {
    try {
      var l = JSON.parse(localStorage.getItem(PEDIDOS) || '[]') || [];
      if (l.indexOf(variante) === -1) l.push(variante);
      localStorage.setItem(PEDIDOS, JSON.stringify(l.slice(-80)));
    } catch (e) {}
  }

  function varianteAtual() {
    var i = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return i ? String(i.value || '') : '';
  }

  function dizer(texto, erro) {
    nota.textContent = texto;
    nota.hidden = !texto;
    nota.classList.toggle('is-erro', !!erro);
  }

  function mostrar() {
    if (!botoes.length || !form) return;
    var esgotado = botoes.some(function (b) {
      return b.hasAttribute('disabled') || b.getAttribute('aria-disabled') === 'true';
    });
    caixa.hidden = !esgotado;
    if (!esgotado) return;
    var v = varianteAtual();
    if (v && jaPediu(v)) {
      form.hidden = true;
      dizer(caixa.dataset.jaPediu || '', false);
    } else {
      form.hidden = false;
      dizer('', false);
    }
  }

  botoes.forEach(function (b) {
    new MutationObserver(mostrar).observe(b, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  });
  document.addEventListener('variant:change', mostrar);
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.name === 'id') mostrar();
  });
  mostrar();

  function pedir() {
    var email = ((caixa.querySelector('input[name=email]') || {}).value || '').trim();
    var variante = varianteAtual();
    if (!email || email.indexOf('@') < 1 || !variante) { dizer(caixa.dataset.erro || '', true); return; }

    var btn = caixa.querySelector('[data-bis-enviar]');
    btn.disabled = true;
    fetch('/apps/ebh/bis', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        email: email, variante: variante,
        handle: caixa.dataset.handle, url: caixa.dataset.url,
        locale: (window.Shopify && Shopify.locale) || '',
        market: (window.Shopify && Shopify.country) || ''
      })
    }).then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        btn.disabled = false;
        if (d && d.ok) {
          guardaPedido(variante);
          form.hidden = true;
          dizer(caixa.dataset.feito || '', false);
        } else {
          dizer(caixa.dataset.erro || '', true);
        }
      })
      .catch(function () { btn.disabled = false; dizer(caixa.dataset.erro || '', true); });
  }

  var enviar = caixa.querySelector('[data-bis-enviar]');
  if (enviar) enviar.addEventListener('click', pedir);
  var campo = caixa.querySelector('input[name=email]');
  if (campo) {
    /* Sem formulário não há Enter de borla — e escrever o email e carregar em
       Enter é o gesto que toda a gente faz. */
    campo.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); pedir(); }
    });
  }
})();
